import * as React from 'react';
import {container, sectiontitle, sectiontext} from './timeline-subheader.module.css'

const TimelineSub = ({ id, title, text }) => {
    return (
        <section className = {container} id = {id}>
            <h3 className = {sectiontitle}>{title}</h3>
            <p className = {sectiontext}>{text}</p>
        </section>
        
    )
}

export default TimelineSub